export enum queryType  {
    preLive = "preLive", live = "live", today = "today"
}
export type sportMessage = { sportId: string, eventsCount: number };